/** i18n 资源里的语言代码 → Intl BCP 47 locale */
const LANG_TO_LOCALE = {
  en: 'en-US',
  sc: 'zh-CN',
  tc: 'zh-TW',
  ge: 'de-DE',
  jp: 'ja-JP',
  ko: 'ko-KR',
  ar: 'ar',
  fr: 'fr-FR',
  es: 'es-ES',
  it: 'it-IT',
  pl: 'pl-PL',
};

function toNumber(input) {
  if (input == null || input === '') return NaN;
  const n = Number(String(input).replace(/,/g, '').trim());
  return n;
}

/**
 * 按货币与当前语言格式化金额（如 HKD → HK$1,234、EUR → €1.234,00）。
 */
export function formatPrice(amount, currencyCode, i18nLanguage) {
  const locale = LANG_TO_LOCALE[i18nLanguage] || i18nLanguage || 'en-US';
  const code = currencyCode ? String(currencyCode).trim().toUpperCase() : '';
  const value = toNumber(amount);

  if (!code || isNaN(value)) {
    if (amount == null || amount === '') return '';
    return code ? `${amount} ${code}` : String(amount);
  }

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: code,
    }).format(value);
  } catch (e) {
    return `${value} ${code}`;
  }
}



// WEBPACK FOOTER //
// ./src/js/utils/formatPrice.js